module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-02-01",
		"endpointPrefix": "elasticfilesystem",
		"protocol": "rest-json",
		"serviceAbbreviation": "EFS",
		"serviceFullName": "Amazon Elastic File System",
		"signatureVersion": "v4",
		"uid": "elasticfilesystem-2015-02-01"
	},
	"operations": {
		"CreateFileSystem": {
			"http": {
				"requestUri": "/2015-02-01/file-systems",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"CreationToken"
				],
				"members": {
					"CreationToken": {},
					"PerformanceMode": {}
				}
			},
			"output": {
				"shape": "S4"
			}
		},
		"CreateMountTarget": {
			"http": {
				"requestUri": "/2015-02-01/mount-targets",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"SubnetId"
				],
				"members": {
					"FileSystemId": {},
					"SubnetId": {},
					"IpAddress": {},
					"SecurityGroups": {
						"shape": "Sg"
					}
				}
			},
			"output": {
				"shape": "Si"
			}
		},
		"CreateTags": {
			"http": {
				"requestUri": "/2015-02-01/create-tags/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"Tags"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					},
					"Tags": {
						"shape": "Sm"
					}
				}
			}
		},
		"DeleteFileSystem": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-02-01/file-systems/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					}
				}
			}
		},
		"DeleteMountTarget": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					}
				}
			}
		},
		"DeleteTags": {
			"http": {
				"requestUri": "/2015-02-01/delete-tags/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"TagKeys"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"DescribeFileSystems": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/file-systems",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"CreationToken": {
						"location": "querystring",
						"locationName": "CreationToken"
					},
					"FileSystemId": {
						"location": "querystring",
						"locationName": "FileSystemId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Marker": {},
					"FileSystems": {
						"type": "list",
						"member": {
							"shape": "S4"
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeMountTargetSecurityGroups": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"SecurityGroups"
				],
				"members": {
					"SecurityGroups": {
						"shape": "Sg"
					}
				}
			}
		},
		"DescribeMountTargets": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/mount-targets",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"FileSystemId": {
						"location": "querystring",
						"locationName": "FileSystemId"
					},
					"MountTargetId": {
						"location": "querystring",
						"locationName": "MountTargetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Marker": {},
					"MountTargets": {
						"type": "list",
						"member": {
							"shape": "Si"
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTags": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/tags/{FileSystemId}/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId"
				],
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Tags"
				],
				"members": {
					"Marker": {},
					"Tags": {
						"shape": "Sm"
					},
					"NextMarker": {}
				}
			}
		},
		"ModifyMountTargetSecurityGroups": {
			"http": {
				"method": "PUT",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					},
					"SecurityGroups": {
						"shape": "Sg"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"required": [
				"OwnerId",
				"CreationToken",
				"FileSystemId",
				"CreationTime",
				"LifeCycleState",
				"NumberOfMountTargets",
				"SizeInBytes",
				"PerformanceMode"
			],
			"members": {
				"OwnerId": {},
				"CreationToken": {},
				"FileSystemId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"LifeCycleState": {},
				"Name": {},
				"NumberOfMountTargets": {
					"type": "integer"
				},
				"SizeInBytes": {
					"type": "structure",
					"required": [
						"Value"
					],
					"members": {
						"Value": {
							"type": "long"
						},
						"Timestamp": {
							"type": "timestamp"
						}
					}
				},
				"PerformanceMode": {}
			}
		},
		"Sg": {
			"type": "list",
			"member": {}
		},
		"Si": {
			"type": "structure",
			"required": [
				"MountTargetId",
				"FileSystemId",
				"SubnetId",
				"LifeCycleState"
			],
			"members": {
				"OwnerId": {},
				"MountTargetId": {},
				"FileSystemId": {},
				"SubnetId": {},
				"LifeCycleState": {},
				"IpAddress": {},
				"NetworkInterfaceId": {}
			}
		},
		"Sm": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticfilesystem-2015-02-01.min.json
// module id = 1322
// module chunks = 0